import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import {
  UploadOutlined,
  LoadingOutlined,
  DeleteFilled
} from '@ant-design/icons'

import { useMerge } from 'components/logic'
import FileBase64 from './FileBase64'
import './ImageUpload.scss'

function ImageUpload({ name = '', image = '', handleChange }) {
  const upload = useMerge('/images/upload')

  const [loading, isLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState()

  const uploadImage = e => {
    const payload = {
      base64Image: e.base64.replace(`data:${e.type};base64,`, ''),
      imageFileExtension: e.type.replace('image/', '')
    }

    isLoading(true)

    upload(payload).then(url => {
      const imageObjet = {
        image: e.base64.replace(`data:${e.type};base64,`, ''),
        type: e.type.replace('image/', ''),
        finalUrl: url.response
      }

      handleChange(imageObjet)
      isLoading(false)
    })
  }

  const handleRemoveImage = () => {
    const imageObjet = {
      image: '',
      type: '',
      finalUrl: ''
    }

    handleChange(imageObjet)
  }

  useEffect(() => {
    if (
      window.location.origin !== 'http://localhost:3000' &&
      window.location.origin !== 'https://medsis-stg.medlevensohn-stage.com' &&
      window.location.origin !== 'https://medsis.medlevensohn.com'
    ) {
      const userIP = window.location.origin.split(window.location.port)[0]

      const updatedImageUrl = image
        ? image?.replace('http://localhost:', userIP)
        : ''
      setImageUrl(updatedImageUrl ?? '')
    }
  }, [image, imageUrl])

  return (
    <div>
      <div className={'new-image'} style={{ maxWidth: '100%' }}>
        <label htmlFor={name} className="form-btn-confirm btn-img">
          <div className="select-image-button">
            {loading ? (
              <LoadingOutlined style={{ marginRight: '5px' }} />
            ) : (
              <UploadOutlined />
            )}
            {loading ? 'Carregando...' : 'Selecionar'}
          </div>
        </label>
        <div style={{ display: 'none' }}>
          <FileBase64 id={name} onDone={uploadImage} />
        </div>
        {image && (
          <div className="preview-wrapper">
            <img
              className="upload-image-preview"
              src={imageUrl ?? image}
              alt="Imagem"
            />
            <Button className="upload-image-cancel" onClick={handleRemoveImage}>
              <DeleteFilled />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageUpload
